import { useAxios, useInfiniteScroll } from '../api/hooks'
import { UseAxios, UseInfiniteScroll } from '../api/types'
import { GetOrdersQueryParams, Order } from './types'

export const useGetOrder = (key: string): UseAxios<Order> =>
  useAxios<Order>({ url: `/orreca/v1/orders/${key}` })

export const useGetPaginatedOrders = (params: GetOrdersQueryParams): UseInfiniteScroll<Order> =>
  useInfiniteScroll({ url: `/orreca/v1/orders`, params })
